module.exports = __webpack_public_path__ + "img/master.0b665880.png";